import type { ReactNode } from 'react'

import { useMe } from '@/api/hooks/useMe'
import { Card, SectionHeader, Skeleton } from '@/shared/ui/Card'

/**
 * Protegge una rotta riservata al ruolo amministratore.
 *
 * Come ModuleGuard, non reindirizza: resta sull'indirizzo chiesto e spiega
 * perché non c'è accesso. È comodità, non sicurezza — le rotte del backend
 * (`admin_companies`) rifiutano comunque chi non ha `role: admin`.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { data, isLoading } = useMe()

  if (isLoading) {
    return (
      <div className="flex flex-1 flex-col gap-4 p-6">
        <Skeleton className="h-8 w-64" label="Verifica dei permessi" />
        <Skeleton className="h-40 w-full" />
      </div>
    )
  }

  if (data?.role !== 'admin') {
    return (
      <div className="flex flex-1 items-start justify-center p-6 sm:p-10">
        <Card className="max-w-md">
          <SectionHeader
            eyebrow="Accesso riservato"
            title="Solo per amministratori"
            description="Questa sezione è visibile solo agli account con ruolo amministratore."
          />
        </Card>
      </div>
    )
  }

  return <>{children}</>
}
